// src/components/user/controltower/ExpressDeliveryCard.jsx
import React from 'react';
import { MapPin, Navigation, Zap, Phone } from 'lucide-react';

const STATUS_STYLES = {
  pending:   { bar: 'bg-orange-400', badge: 'bg-orange-100 text-orange-700', label: 'Pendiente' },
  encamino:  { bar: 'bg-blue-400',   badge: 'bg-blue-100 text-blue-700',     label: 'En Camino' },
  entregado: { bar: 'bg-green-400',  badge: 'bg-green-100 text-green-700',   label: 'Entregado' },
  cancelado: { bar: 'bg-red-400',    badge: 'bg-red-100 text-red-700',       label: 'Cancelado' },
  rechazado: { bar: 'bg-red-400',    badge: 'bg-red-100 text-red-700',       label: 'Rechazado' },
};

export function ExpressDeliveryCard({ delivery, onClick, isSelected }) {
  const s = STATUS_STYLES[delivery.status] || { bar: 'bg-slate-300', badge: 'bg-slate-100 text-slate-600', label: delivery.status };

  return (
    <button
      onClick={onClick}
      className={`w-full text-left flex items-stretch transition-colors ${
        isSelected ? 'bg-brand-green/5' : 'hover:bg-slate-50'
      }`}
    >
      {/* Green status bar for express */}
      <div className={`w-1 flex-shrink-0 bg-brand-green`} />

      <div className="flex-1 px-3 py-3 space-y-1.5 min-w-0">
        {/* Header */}
        <div className="flex items-center justify-between gap-2">
          <div className="flex items-center gap-1.5 min-w-0">
            <Zap className="w-3 h-3 text-brand-green shrink-0" />
            <span className="text-xs font-bold text-slate-400 font-montserrat shrink-0">#{delivery.id}</span>
            <p className="text-sm font-bold text-slate-900 font-montserrat truncate">{delivery.recipient_name}</p>
          </div>
          <div className="flex items-center gap-1.5 shrink-0">
            <span className={`text-xs font-semibold px-1.5 py-0.5 rounded-full text-white font-montserrat ${delivery.vehicle_type === 'bike' ? 'bg-brand-green' : 'bg-brand-primary'}`}>
              {delivery.vehicle_type === 'bike' ? '🏍' : '🚗'}
            </span>
            <span className={`text-xs font-semibold px-2 py-0.5 rounded-full font-montserrat ${s.badge}`}>
              {s.label}
            </span>
          </div>
        </div>

        {/* Pickup */}
        <div className="flex items-start gap-1.5">
          <MapPin className="w-3 h-3 text-brand-primary mt-0.5 shrink-0" />
          <p className="text-xs text-slate-500 font-montserrat line-clamp-1">{delivery.pickup_address}</p>
        </div>

        {/* Dropoff */}
        <div className="flex items-start gap-1.5">
          <Navigation className="w-3 h-3 text-brand-green mt-0.5 shrink-0" />
          <p className="text-xs text-slate-500 font-montserrat line-clamp-1">{delivery.dropoff_address}</p>
        </div>

        {/* Phone + price */}
        <div className="flex items-center justify-between">
          {delivery.recipient_phone && (
            <div className="flex items-center gap-1">
              <Phone className="w-3 h-3 text-slate-400" />
              <span className="text-xs text-slate-500 font-montserrat">{delivery.recipient_phone}</span>
            </div>
          )}
          <span className="text-xs font-extrabold text-brand-green font-montserrat ml-auto">
            S/ {Number(delivery.total_price).toFixed(2)} · {delivery.distance_km} km
          </span>
        </div>
      </div>
    </button>
  );
}